module.exports = __webpack_public_path__ + "img/imge2.1756f6d2.png";